import WaveformData from 'waveform-data';

const originalOffsetValues = WaveformData.prototype.offsetValues;

// Cachea resultados del metodo offsetValues para mejor performance
// Ver https://github.com/bbc/waveform-data.js/issues/27
WaveformData.prototype.offsetValues = function patchedGetOffsetValues(
  start: any,
  length: any,
  correction: any,
) {
  const key = `${start}_${length}_${correction}`;

  if (!this._cachedOffsetValues) {
    this._cachedOffsetValues = {};
  }

  if (!this._cachedOffsetValues[key]) {
    this._cachedOffsetValues[key] = originalOffsetValues.apply(this, [start, length, correction]);
  }

  return this._cachedOffsetValues[key];
};
